import { Text, VStack } from '@genial/components';
import { Spacing, Typography } from '@genial/design-tokens';
import React from 'react';

import { CategoryDivider } from '../CategoryDivider';
import { ZoomableImage } from '../ZoomableImage';

export const FastTicket: React.FC = () => {
  return (
    <VStack space={Spacing['stack.sm']}>
      <Text fontSize={Typography['fontsize.xxl']} variant="bold">
        Boleta Fácil
      </Text>
      <VStack space={Spacing['stack.xxxs']}>
        <CategoryDivider>Acumulado - Ordens e Executando</CategoryDivider>
        <ZoomableImage source="https://pb-gen-data-report.s3.amazonaws.com/accumulated_orders.svg" />
        <CategoryDivider>Quantidade de Ordens por Status por Produto</CategoryDivider>
        <ZoomableImage source="https://pb-gen-data-report.s3.amazonaws.com/orders_per_status.svg" />
        <CategoryDivider>Rejeitados por Dia no Mês Atual</CategoryDivider>
        <ZoomableImage source="https://pb-gen-data-report.s3.amazonaws.com/daily_rejected.svg" />
        <ZoomableImage source="https://pb-gen-data-report.s3.amazonaws.com/average_rejected.svg" />
        <CategoryDivider>Utilização da Boleta Fácil</CategoryDivider>
        <ZoomableImage source="https://pb-gen-data-report.s3.amazonaws.com/monthly_usage.svg" />
        <ZoomableImage source="https://pb-gen-data-report.s3.amazonaws.com/acceptance_channel.svg" />
        <ZoomableImage source="https://pb-gen-data-report.s3.amazonaws.com/products_executed.svg" />
        <CategoryDivider>Funil de Conversão de Ordens</CategoryDivider>
        <ZoomableImage source="https://pb-gen-data-report.s3.amazonaws.com/month_forecast.svg" />
        <ZoomableImage source="https://pb-gen-data-report.s3.amazonaws.com/accumulated_orders.svg" />
        <CategoryDivider>Conversão de Ordens (Últimos 15 Dias)</CategoryDivider>
        <ZoomableImage source="https://pb-gen-data-report.s3.amazonaws.com/conversion_last_15_days.svg" />
        <ZoomableImage source="https://pb-gen-data-report.s3.amazonaws.com/conversion_last_15_days_perc.svg" />
        <CategoryDivider>Funil de Conversão de Ordens</CategoryDivider>
        <ZoomableImage source="https://pb-gen-data-report.s3.amazonaws.com/conversion_funnels.svg" />
        <CategoryDivider>Assessor Top 10</CategoryDivider>
        <ZoomableImage source="https://pb-gen-data-report.s3.amazonaws.com/top10_orders_count.svg" />
        <ZoomableImage source="https://pb-gen-data-report.s3.amazonaws.com/top10_orders_values.svg" />
      </VStack>
    </VStack>
  );
};
